import { useConfig } from '@browsing/config';
import { useVariant } from '@pegasus/abtesting';
export var useKeepArticlesInCartFeature = function () {
    var config = useConfig();
    var isKeepArticleInCartFeatureFlagEnabled = config.isEnabled('keepArticlesInCart');
    var isKeepArticleInCartABTestEnabled = !!useVariant('convert-keep-article-in-cart', 'variant_keep_article_cart');
    return isKeepArticleInCartFeatureFlagEnabled && isKeepArticleInCartABTestEnabled;
};
